import { cache } from '@/container/apollo-client/cache';
import { SUBSCRIPTION_MESSAGE_CONVERSATION_FRAGMENT } from '@/graphql/cache/cache-mutations';
import { CURSOR_MESSAGES } from '@/graphql/cursor.graphql';
import { MessageConversationSubscription, MessageConversationsV2Query } from '@/types/generated/graphql';

export function messageConversationHandler(data: MessageConversationSubscription) {
  if (!data?.messageConversation) return;

  // normalize the entity unconditionally, so cross-handler __ref lookups (recentMessageHandler)
  // resolve even for a conversation whose message list was never fetched into cache
  cache.writeFragment({
    id: 'MessageConversation:' + data.messageConversation.id,
    fragment: SUBSCRIPTION_MESSAGE_CONVERSATION_FRAGMENT,
    data: data.messageConversation,
  });

  const cachedMessages = cache.readQuery<MessageConversationsV2Query>({
    query: CURSOR_MESSAGES,
    variables: {
      clientId: data?.messageConversation?.client?.id,
      channelId: data?.messageConversation?.channelId,
    },
  });
  // need to check this condition because in case of primary sender among groups, it would be already appended
  const alreadyAppendedToCache = cachedMessages?.messageConversationsV2?.data?.find(
    (message) => message?.id === data?.messageConversation?.id
  );

  // conversation's message list was never fetched into cache (thread not opened this session) —
  // nothing to append to; fabricating a fresh { data: [...] } result here would make a later
  // cache-first open of this conversation wrongly treat that single message as the full history
  if (!cachedMessages?.messageConversationsV2) {
    return;
  }

  if (alreadyAppendedToCache) {
    return;
  }

  cache.updateQuery(
    {
      query: CURSOR_MESSAGES,
      variables: {
        clientId: data?.messageConversation?.client?.id,
        channelId: data?.messageConversation?.channelId,
      },
    },
    (cachedData) => {
      return {
        ...cachedData,
        messageConversationsV2: {
          ...cachedData?.messageConversationsV2,
          data: [data?.messageConversation, ...(cachedData?.messageConversationsV2?.data || [])],
        },
      };
    }
  );
}
